import loglevel from 'loglevel';

const log = loglevel.getLogger("auth");
log.setLevel("error");

export { log };
